import pb from '../lib/pocketbase';

export async function getCotizaCabs(page, perPage) {
  return await pb.collection('cotiza_cab').getList(page, perPage, {
    sort: '-created', // Ordenar por fecha de creación descendente
    $autoCancel: false,
    expand: 'cotiza_det' // Expandir detalles de la cotización
  });
}

export async function createCotizaCab(cotizaCab) {
  return await pb.collection('cotiza_cab').create(cotizaCab);
}

export async function updateCotizaCab(id, cotizaCab) {
  return await pb.collection('cotiza_cab').update(id, cotizaCab);
}

export async function deleteCotizaCab(id) {
  return await pb.collection('cotiza_cab').delete(id);
}

export async function getCotizaCabById(id) {
  return await pb.collection('cotiza_cab').getOne(id, {
    expand: 'cotiza_det.producto'
  });
}

export async function getCotizaCabsByDateRange(startDate, endDate, page, perPage) {
  return await pb.collection('cotiza_cab').getList(page, perPage, {
    filter: `fecha >= "${startDate}" && fecha <= "${endDate}"`,
    sort: '-fecha',
    $autoCancel: false,
    expand: 'cotiza_det'
  });
}

export async function getCotizaCabsByClient(nit, page, perPage) {
  return await pb.collection('cotiza_cab').getList(page, perPage, {
    filter: `nit = "${nit}"`,
    sort: '-created',
    $autoCancel: false,
    expand: 'cotiza_det'
  });
}
